import { gql } from '@apollo/client';
export const UPDATE_DEPARTMENT= gql`
mutation(
   $input:DepartmentsUpdateInput!
  ){
    updateDepartmentsDetails(input: $input) {

    _id
    name
    slug
    icon
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
  }`;
